import { useDispatch, useSelector } from 'react-redux'
import { updateMediaTags } from 'photo-module/photos/core/photosActions'
import { useTranslation } from 'react-i18next'
import useSelectedPhoto from 'photo-module/photo/core/useSelectedPhoto'
import useLoadingActions from 'shared-module/loading/useLoadingActions'

const LOADING_KEY = 'updateMediaTags'

const usePhotoTagging = () => {
  const dispatch = useDispatch()
  const loading = useSelector(state => state.loading)
  const loadingActions = useLoadingActions()
  const isUpdating = loadingActions.isLoading(loading, LOADING_KEY)

  const updatePhotoTags = async (updatedTags) => {
    try {
      if (!updatedTags || !updatedTags.mediaIds || updatedTags.mediaIds.length === 0) {
        return { success: false, error: 'No media IDs provided' }
      }

      if (!updatedTags.tags || !updatedTags.tags.species) {
        return { success: false, error: 'No tags provided' }
      }

      await dispatch(updateMediaTags(updatedTags))
      return { success: true }
    } catch (error) {
      return { success: false, error: error.message }
    }
  }

  return {
    updatePhotoTags,
    isUpdating,
  }
}

export default usePhotoTagging
